import React, { useState, useEffect } from 'react'
import BuyerRequest from '../Modules/BuyerUser/Request'
import {DataBuyer} from '../Modules/BuyerUser/DataBuyer'

interface BuyerUserHookResult {
  dataBuyer: DataBuyer 
  loading: boolean
  error: any
  u: string
  isAgency: boolean
}

export const useBuyerUser = (publicToken, search: string, pathname: string): BuyerUserHookResult => {
  const [dataBuyer, setDataBuyer] = useState<DataBuyer>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<any>(null)
  
  // const search = window.location.search
  const params = new URLSearchParams(search)
  const uParam = params.get('u')
  
  useEffect(() => {
    if (uParam) {
      console.log('tiene u')
      setLoading(true)
      setError(null) // Clear previous errors
      BuyerRequest.getBuyerUser(publicToken, uParam)
        .then(result => {
          console.log('result: ', result)
          setDataBuyer(result.toSend?.buyerUser)
        })
        .catch((err) => {
          console.error('error getBuyer - error: ', err)
          setError(err)
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }, [publicToken, search, pathname])

  const isAgency = !!dataBuyer?.client?.agency
  
  // @ts-ignore
  return { dataBuyer, loading, error, u: params.get('u'), isAgency }
}